export default "__VITE_ASSET__DOsgOIDQ__"